var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-input"},[(_vm.icon)?_c('img',{staticClass:"icon-input",attrs:{"src":_vm.icon},on:{"click":function($event){_vm.$emit('click')}}}):_vm._e(),_vm._v(" "),_c('input',{staticClass:"custom-input-input",attrs:{"readonly":_vm.readonly},domProps:{"value":_vm.formattedView}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33594353","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/ui/p-input-icon.vue
// module id = 3092
// module chunks = 24